import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomeSA from '../presentation/pages/superAdmin/home/HomeSA';
import { TermosOfUse } from '../presentation/pages/superAdmin/home/Settings/TermsOfUse';
import { Privacy } from '../presentation/pages/superAdmin/home/Settings/Privacy';

export default function SuperAdminRoutes() {
  return (
    <Routes>
      <Route path="/home" element={<HomeSA />} />
      <Route path="/terms-of-use" element={<TermosOfUse />} />
      <Route path="/privacy" element={<Privacy />} />
    </Routes>
  );
}
